import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Globals } from "../globals";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ChangeLangService {
  constructor(
    private translate: TranslateService,
    private globals: Globals,
    private router: Router
  ) {}
  selected = localStorage.getItem("selectedLang")
    ? localStorage.getItem("selectedLang")
    : "en";

  setInitialAppLanguage() {
    let language = localStorage.getItem("selectedLang")
      ? localStorage.getItem("selectedLang")
      : "en";

    this.translate.setDefaultLang(language);
    this.setLanguage(this.selected);
    // this.storage.get(Configs.getLangKeyName).then(val => {
    //     if (val) {
    //         this.setLanguage(val);
    //         this.selected = val;
    //     }
    // });
  }

  getSelectedLanguage() {
    return this.selected;
  }

  setLanguage(lng) {
    this.translate.use(lng);
    this.selected = lng;
    localStorage.setItem("selectedLang", lng);
    var htmlElm = document.getElementsByTagName("html")[0];
    if (lng == "ar") {
      htmlElm.classList.add("arabic");
      htmlElm.setAttribute("lang", "ar");
      htmlElm.setAttribute("dir", "rtl");
    } else {
      htmlElm.classList.remove("arabic");
      htmlElm.setAttribute("lang", "en");
      htmlElm.setAttribute("dir", "ltr");
    }
  }

  changeLanguage() {
    if (this.selected == "en") {
      this.setLanguage("ar");
    } else {
      this.setLanguage("en");
    }
    this.router.navigate(["login"]);
    setTimeout(() => {
      window.location.reload();
    }, 0);
  }
}
